import { render, staticRenderFns } from "./userRegistor.vue?vue&type=template&id=c8586542&scoped=true&"
import script from "./userRegistor.vue?vue&type=script&lang=js&"
export * from "./userRegistor.vue?vue&type=script&lang=js&"
import style0 from "./userRegistor.vue?vue&type=style&index=0&id=c8586542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8586542",
  null
  
)

export default component.exports